import { StringColumn } from 'baseui/data-table';
import dayjs from 'dayjs';
import _get from 'lodash/get';

export const COL_NAMES = {
	updatedby: 'updatedby',
	description: 'description',
	newValue: 'newValue',
	updatedAt: 'updatedAt',
	createdAt: 'createdAt'
};

export const columnConfigs = [
	StringColumn({
		title: 'Updated By',
		mapDataToValue: (data: any) => data[COL_NAMES.updatedby]
	}),
	StringColumn({
		title: 'Description',
		mapDataToValue: (data: any) => data[COL_NAMES.description]
	}),
	StringColumn({
		title: 'Value',
		mapDataToValue: (data: any) => data[COL_NAMES.newValue]
	}),
	StringColumn({
		title: 'Updated At',
		mapDataToValue: (data: any) => {
			return _get(data, COL_NAMES.updatedAt)
				? dayjs(new Date(_get(data, COL_NAMES.updatedAt))).format('DD-MM-YYYY hh:mm A')
				: 'NA';
		}
	}),
	StringColumn({
		title: 'Created At',
		mapDataToValue: (data: any) => {
			return _get(data, COL_NAMES.createdAt)
				? dayjs(new Date(_get(data, COL_NAMES.createdAt))).format('DD-MM-YYYY hh:mm A')
				: 'NA';
		}
	})
];
